
<img *ngIf="NDDTypeOpen && !isArticle"
  src="assets/images/icon/Delivery.png"
  class="icon-item a-walai img-color-navy"
  title="Delivery"
  (click)="openRD(item)"
  [hidden]="!_CheckOpenRDByCollection"
/>

<a *ngIf="NDDTypeOpen && isArticle"  
  role="button" 
  class="btn btn-primary btn-sm py-1 fw-light shadow me-2" 
  (click)="openRD(item)"
  [hidden]="!_CheckOpenRDByCollection">
  <img 
  src="assets/images/icon/Delivery.png"
  class="img-color-white icon-w-25"
  title="Delivery"

/> <span class="my-auto ms-1">Resource delivery</span> 
</a>
